import { useEffect, useState } from "react";
import { getApiUrl } from "../api";
import AidApplication from "./AidApplication";
import Header from "../component/Header";
import Footer from "../component/Footer";
import "../styles/partner-application.css";

async function loadInvitation(secureToken) {
  const url = new URL(getApiUrl("/api/PartnerApplicationWorkflow.ashx"), window.location.origin);
  url.searchParams.set("action", "INVITE");
  url.searchParams.set("token", secureToken);
  const response = await fetch(url, { headers: { Accept: "application/json" } });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.success === false) throw new Error(payload.message || "Unable to open the partner application.");
  return payload.data;
}

function startUaePassVerification() {
  const authorizeUrl = process.env.REACT_APP_UAE_PASS_AUTHORIZE_URL || "https://id.uaepass.ae/idshub/authorize";
  const clientId = process.env.REACT_APP_UAE_PASS_CLIENT_ID || "tarahum_webr_prod";
  const redirectUri = process.env.REACT_APP_UAE_PASS_REDIRECT_URI || `${window.location.origin}/uae-pass-callback`;
  const scope = process.env.REACT_APP_UAE_PASS_SCOPE || "urn:uae:digitalid:profile:general";
  const acrValues = process.env.REACT_APP_UAE_PASS_ACR_VALUES || "urn:safelayer:tws:policies:authentication:level:low";
  const random = () => `${Date.now()}-${window.crypto?.randomUUID?.() || Math.random().toString(16).slice(2)}`;
  const state = `uaepass_${random()}`;
  const nonce = random();
  window.sessionStorage.setItem("tarahumUaePassState", state);
  window.sessionStorage.setItem("tarahumUaePassNonce", nonce);
  window.sessionStorage.setItem("tarahumUaePassReturnTo", `${window.location.pathname}${window.location.search}`);
  const params = new URLSearchParams({ response_type: "code", client_id: clientId, redirect_uri: redirectUri, scope, state, nonce });
  if (acrValues) params.set("acr_values", acrValues);
  window.location.assign(`${authorizeUrl}?${params.toString()}`);
}

export default function PartnerApplication({ language = "en" }) {
  const secureToken = new URLSearchParams(window.location.search).get("token") || "";
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!secureToken) { setError("The partner application link is missing or invalid."); return; }
    loadInvitation(secureToken).then(setInvite).catch((reason) => setError(reason.message));
  }, [secureToken]);

  if (invite) return <AidApplication language={language} partnerContext={{ ...invite, token: secureToken }} />;

  const needsUaePass = /uae pass/i.test(error);
  return <><Header /><main className="partner-application-page"><section className="partner-application-shell"><div className="partner-access-card">
    <div className="partner-access-icon">✓</div>
    <h1>{error ? "Applicant verification required" : "Opening your application…"}</h1>
    <p>{error || "Verifying your Tarahum profile and secure invitation."}</p>
    {needsUaePass ? <button type="button" onClick={startUaePassVerification}>Verify with UAE PASS</button> : null}
  </div></section></main><Footer /></>;
}
